import React, { Component } from 'react';
import { Button } from '@mui/material';
import styled, { keyframes } from 'styled-components';
import { withTranslation } from 'react-i18next';
import { faCopy, faPen, faTrash, faBookOpen, faArchive } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { isIE, isEdge } from '../../../../common/utilities/browserDetection';
import { getHyperfindLabel } from '../../../utils';

import { AdminSidePanelActionNames, getRequestTypeLabel, getRequestSubTypeLabel } from '../../../Enums';

import { AdminDetailsTooltip } from "./AdminDetailsTooltip"

import { WarningIconWithTooltip } from '../../../../common-client2/src/components';
import { CONFIGURATION_SET_COLUMNS, ConfigurationSetColumnKey } from './configurationSetColumns';
import './ConfigurationSetTableRow.scss';

const leftMove = keyframes`
  0% {
    opacity: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    transform : translateX(0px);
  }
`
const growing = keyframes`
  0% {
    opacity: 0;
    flex: 0;
    transform : translateX(200px);
  }
  100% {
    opacity: 1;
    flex: 1;
    transform : translateX(0px);
  }
`
const RowItem = styled.div`
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  position: relative;
  align-items: center;
  display: flex;
  animation: ${leftMove} ${props => 200 + (props.$index * 40)}ms linear;
  border-radius: 5px;
  padding: 0;
`

const ItemTitle = styled.div`
  padding: 0 5px;
  flex: 0 0 auto;
`
const Buttons = styled.div`
  position: relatice;
  display: flex;
  animation: ${growing} 200ms linear;
`

class ConfigurationSetTableRow extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showButtons: false,
		};
	}

	getApprovalLabel = (isAutoApproval) => {
		return isAutoApproval
			? this.props.t('form.autoApproval')
			: this.props.t('form.manualApproval')
	}

	showButtonsHandler = (state) => {
		this.setState({ showButtons: state })
	}

	dotsContainer = () => {
		return <div></div>
	}

	buttonsHandler = (e, action) => {
		e.stopPropagation();
		this.props.showRightPanel(action, this.props.item)
	}

	buttonsContainer = () => {
		let { t, item: { isUsedAdminSetting }, isEditable, isDeletable } = this.props;

		return (
			<Buttons>
				{ isEditable
				? (
					<Button
						className="cstr-buttons-action"
						onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Edit) }}
					>
						<FontAwesomeIcon
							className="cstr-font-awesome-icon"
							icon={faPen} />
						{t('settings.edit')}
					</Button>)
				: (
					<Button
						className="cstr-buttons-action"
						onClick={(e) => { this.buttonsHandler(e, t('settings.view')) }}
					>
						<FontAwesomeIcon
							className="cstr-font-awesome-icon"
							icon={faBookOpen} />
						{t('settings.view')}
					</Button>
				)}
				<Button
					className="cstr-buttons-action"
					onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Duplicate) }}
				>
					<FontAwesomeIcon
						className="cstr-font-awesome-icon"
						icon={faCopy}
					/>
					{t('settings.duplicate')}
				</Button>
				{
					!isUsedAdminSetting
						? (
							isDeletable && (
								<Button
									className="cstr-buttons-action"
									onClick={(e) => { this.buttonsHandler(e, AdminSidePanelActionNames.Delete) }}
									// title={t('settings.deletable')} // TODO D. 23-10-05 (when FE Refactor)
								>
									<FontAwesomeIcon
										className="cstr-font-awesome-icon"
										icon={faTrash}
									/>
									{t('settings.delete')}
								</Button>)
						)
						: (
							<Button
								className="cstr-buttons-action"
								onClick={(e) => {
									this.buttonsHandler(e, AdminSidePanelActionNames.Archive);
								}}
								// title={t('settings.archivable')} // TODO D. 23-10-05 (when FE Refactor)
							>
								<FontAwesomeIcon
									className="cstr-font-awesome-icon"
									icon={faArchive}
								/>
								{t('settings.archive')}
							</Button>
						)
				}
			</Buttons>)
	}

	render() {
		const { item, index, hyperFindList, t, columnWidths } = this.props;
		let buttonsSection = !this.state.showButtons ? this.dotsContainer() : this.buttonsContainer();
		let description = (item.description.length > 30) ? item.description.substring(0, 27) + "..." : item.description;
		const warnings = item.warnings?.map(x => t(`admin.warnings.${x}`));

		const cellRenderers = {
			[ConfigurationSetColumnKey.Name]: () => (
				<AdminDetailsTooltip data={item} translate={ "AdminRequestSetup."}>
					<div className="cstr-name-font-weight" style={{ display: 'inline-block', width: 'fit-content' }}>
						{item.name}
					</div>
				</AdminDetailsTooltip>
			),
			[ConfigurationSetColumnKey.Warning]: () => (!!warnings && !!warnings.length) ? <WarningIconWithTooltip tooltipWarnings={warnings}/> : <></>,
			[ConfigurationSetColumnKey.Description]: () => description,
			[ConfigurationSetColumnKey.ApprovalProcess]: () => item.autoApproval ? t(`settings.autoApproval`) : t(`settings.manualApproval`),
			[ConfigurationSetColumnKey.RequestType]: () => getRequestTypeLabel(item.actionType),
			[ConfigurationSetColumnKey.RequestSubtype]: () => getRequestSubTypeLabel(item.actionType, item.requestSubtype),
			[ConfigurationSetColumnKey.CreationHyperfind]: () => getHyperfindLabel(item.creationHyperfindId, hyperFindList),
			[ConfigurationSetColumnKey.ManagementHyperfind]: () => getHyperfindLabel(item.managementHyperfindId, hyperFindList),
		};

		return (
			<RowItem
				$index={index}
				className="cstr-quota-item"
				onMouseOver={() => { this.showButtonsHandler(true) }}
				onMouseLeave={() => { this.showButtonsHandler(false) }}>
				{CONFIGURATION_SET_COLUMNS.map((col) => (
					<ItemTitle key={col.key} className={col.cellClassName} style={{ width: `${columnWidths[col.key]}%` }}>
						{cellRenderers[col.key]()}
					</ItemTitle>
				))}
				<div className={['cstr-button-section', (isIE() || isEdge()) ? 'cstr-adjustment' : ''].join(' ')}>
					{buttonsSection}
				</div>
			</RowItem>
		)
	}
}

export default withTranslation('employmentBillboard')(ConfigurationSetTableRow);